import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useColleagueQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const useColleagueQuery = colleagueId => useQuery({
        queryKey: ["colleague", colleagueId],
        queryFn: ({ queryKey }) => {
            const id = queryKey[1];
            return axiosPrivate.get(`colleague/${id}/`).then(res => res.data);
        },
    });

    const getForBusinessQuery = useQuery({
        queryKey: ["colleague", "get_for_business"],
        queryFn: () => axiosPrivate.get("colleague/get_for_business/").then(r => r.data),
    });

    const getUserQuery = useQuery({
        queryKey: ["colleague", "get_user"],
        queryFn: () => axiosPrivate.get("colleague/get_user/").then(r => r.data),
    });

    const getRoleForColleagueQuery = useQuery({
        queryKey: ["colleague", "get_role_for_colleague"],
        queryFn: (colleagueId) =>
            axiosPrivate.get(`colleague/get_role_for_colleague/?colleague=${colleagueId}`).then(r => r.data),
        enabled: false, // call manually with refetch
    });

    // MUTATIONS ---------------------------------------------------
    const savePushTokenMutation = useMutation({
        mutationFn: (token) => axiosPrivate.post("colleague/save_push_token/", { token }).then(r => r.data),
    });

    const updateColleagueMutation = useMutation({
        mutationFn: ({id, data}) => axiosPrivate.patch(`colleague/${id}/`, data, {headers: {'Content-Type': 'multipart/form-data'}}).then(r => r.data),
        onSuccess: (...args) => {
            queryClient.invalidateQueries(["colleague"]);
        },
    });


    const changePasswordMutation = useMutation({
        mutationFn: (data) => axiosPrivate.post("colleague/change_password/", data).then(r => r.data),
        onSuccess: (...args) => {
            queryClient.invalidateQueries(["colleague", "get_user"]);
        },
    });

    const deleteUserMutation = useMutation({
        mutationFn: (id) => axiosPrivate.post(`colleague/delete_user/`, {id}).then(r => r.data),
        onSuccess: (...args) => {
            queryClient.invalidateQueries(["colleague", "delete_user"]);
        },
    });

    const changeRoleMutation = useMutation({
        mutationFn: (data) => axiosPrivate.post("colleague/change_role/", data).then(r => r.data),
        onSuccess: (...args) => {
            queryClient.invalidateQueries(["colleague", "change_role"]);
        },
    });

    return {
        // Queries
        getForBusinessQuery,
        useColleagueQuery,
        getUserQuery,
        getRoleForColleagueQuery,

        // Mutations
        updateColleagueMutation,
        savePushTokenMutation,
        changePasswordMutation,
        deleteUserMutation,
        changeRoleMutation,
    };
}
